import { MANUAL_PATHS, buildManualUrl } from "./manualUrl";

/** 操作ログアップロード時のファイルサイズ制限（10MB） */
export const OPERATION_LOG_UPLOAD_SIZE_LIMIT_BYTES = 10 * 1024 * 1024;

/** サイズオーバー時の警告メッセージ */
export const OPERATION_LOG_SIZE_OVER_MESSAGE =
  "操作ログのファイルサイズが10MBを超えているため、アップロードできません。";

/**
 * 回避策案内テキスト。{{MANUAL_LINK}} の部分を Link コンポーネントで「こちら」に差し替える。
 */
export const OPERATION_LOG_SIZE_OVER_GUIDANCE_TEXT =
  "ファイルサイズの削減方法は{{MANUAL_LINK}}をご参照ください。";

/** マニュアルリンク用URL（テストターゲット管理ツール > 操作ログのインポート > 操作ログのサイズ削減） */
export const OPERATION_LOG_SIZE_OVER_MANUAL_URL = buildManualUrl(
  MANUAL_PATHS.operationLogSizeReduction,
);
